import { observer } from "mobx-react";

import EditModal from "@component/EditModal";
import Note from "@model/Note";
import NoteEditVM from "@vm/Edit/Note";

import NoteForm from "./Form";
import { lazyInject, TYPES } from "../../../inversify.config";

@observer
export default class NoteEdit extends EditModal<Note> {
  modelName = "note";
  prefix = "employee";

  @lazyInject(TYPES.NoteEdit)
  vm: NoteEditVM;

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_notes(this.props.match.params.user_id));
  };

  setIdFromParams() {
    this.vm.init(this.getId(), this.props.match.params.user_id);
  }

  renderModalBody() {
    return (
      <>
        <NoteForm entity={this.vm.entity} />
      </>
    );
  }
}
